export const categories = [
  { slug: 'mingxing-tafang', name: '明星塌房', icon: 'ri-user-star-line', description: '最新明星塌房现场直击，一手明星丑闻与娱乐圈猛料' },
  { slug: 'wanghong-heiliao', name: '网红黑料', icon: 'ri-live-line', description: '全网网红翻车合集，网红私生活爆料与扒皮' },
  { slug: 'chigua-video', name: '吃瓜视频', icon: 'ri-vidicon-line', description: '黑料吃瓜视频在线观看，最新爆料视频合集' },
  { slug: '51-heiliao', name: '51黑料', icon: 'ri-fire-line', description: '51黑料吃瓜入口，每日最新不打烊猛料' },
  { slug: '91-heiliao', name: '91黑料', icon: 'ri-flashlight-line', description: '91黑料吃瓜专区，网红圈内幕大揭秘' },
  { slug: 'mengliao', name: '网曝猛料', icon: 'ri-alert-line', description: '网曝一区二区猛料不停，网友匿名投稿专区' },
];

export const hotArticles = [
  {
    id: 1,
    slug: 'dingji-nanxing-hunwaiqing-baoguang',
    title: '某顶流男星被曝婚外情，深夜与神秘女子共进晚餐后被拍',
    excerpt: '据知情人士透露，该男星已婚多年，却在深夜被拍到与一位神秘女子举止亲密。两人在一家高档日料店共进晚餐后，一同返回酒店，直到次日凌晨才分别离开。',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20paparazzi%20night%20shot%20of%20a%20celebrity%20couple%20walking%20together%20on%20a%20dimly%20lit%20street%2C%20blurry%20background%20with%20city%20lights%2C%20dramatic%20moody%20atmosphere%2C%20cinematic%20photography%20style%2C%20dark%20tones%20with%20warm%20street%20lamp%20highlights%2C%20editorial%20quality&width=800&height=500&seq=article-hot-01&orientation=landscape',
    author: '吃瓜前线',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20icon%20with%20watermelon%20slice%20motif%20on%20clean%20white%20background%2C%20flat%20design%2C%20warm%20red%20and%20green%20colors&width=80&height=80&seq=avatar-01&orientation=squarish',
    publishDate: '2026-07-07',
    readCount: '128.5万',
    commentCount: '3.2万',
    isHot: true,
    isExclusive: true,
    tags: ['顶流', '婚外情', '实拍'],
  },
  {
    id: 2,
    slug: 'qianwan-fensi-wanghong-bei-chuixu',
    title: '千万粉丝网红被实锤虚假人设，背后团队操作细节全曝光',
    excerpt: '某拥有超过1500万粉丝的头部网红，被前团队成员实名举报长期制造虚假人设。从精心设计的"偶遇"到剧本化的"日常"，每一个看似真实的瞬间都经过了精密策划。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20social%20media%20live%20stream%20with%20dramatic%20lighting%2C%20behind%20the%20scenes%20film%20crew%20equipment%20in%20the%20background%2C%20dark%20moody%20atmosphere%2C%20cinematic%20composition%2C%20contrast%20between%20screen%20glow%20and%20dark%20surroundings&width=800&height=500&seq=article-hot-02&orientation=landscape',
    author: '扒圈老手',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20detective%20style%20avatar%20icon%20with%20magnifying%20glass%20motif%20on%20clean%20white%20background%2C%20flat%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    publishDate: '2026-07-06',
    readCount: '96.3万',
    commentCount: '2.8万',
    isHot: true,
    isExclusive: true,
    tags: ['虚假人设', '团队爆料', '实锤'],
  },
  {
    id: 3,
    slug: 'mou-nvxing-luoliao-baoguang',
    title: '某女星聊天记录被曝光，与多名圈内人士暧昧对话内容惊人',
    excerpt: '一组涉及某知名女星的聊天记录截图在社交平台疯传。记录中她与多位圈内人士保持着暧昧关系，其中不乏已婚人士，对话内容尺度之大令人咋舌。',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20chat%20messages%20with%20blurred%20text%20on%20a%20dark%20wooden%20desk%2C%20dim%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20dark%20tones&width=800&height=500&seq=article-hot-03&orientation=landscape',
    author: '娱乐观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20eye%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design%2C%20dark%20warm%20colors&width=80&height=80&seq=avatar-03&orientation=squarish',
    publishDate: '2026-07-06',
    readCount: '185.2万',
    commentCount: '5.6万',
    isHot: true,
    isExclusive: false,
    tags: ['聊天记录', '暧昧', '女星'],
  },
  {
    id: 4,
    slug: 'zhibo-daiban-jiamao-bei-jiechuan',
    title: '直播带货翻车！某大主播带货产品被检测出有害物质超标',
    excerpt: '消费者协会最新抽检结果显示，某头部带货主播推荐的护肤品中检测出超标有害物质。该主播曾在直播间信誓旦旦保证产品"绝对安全"，如今却面临信任危机。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cosmetic%20product%20on%20a%20laboratory%20testing%20table%20with%20test%20tubes%20and%20scientific%20equipment%2C%20clean%20sterile%20white%20environment%2C%20professional%20lighting%2C%20product%20photography%20style%2C%20clinical%20aesthetic&width=800&height=500&seq=article-hot-04&orientation=landscape',
    author: '消费警示',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20shield%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design%2C%20warm%20protective%20colors&width=80&height=80&seq=avatar-04&orientation=squarish',
    publishDate: '2026-07-05',
    readCount: '73.8万',
    commentCount: '1.9万',
    isHot: false,
    isExclusive: false,
    tags: ['直播带货', '翻车', '检测'],
  },
  {
    id: 5,
    slug: 'yinyuejie-dalao-bei-zhi-qianzhai',
    title: '音乐圈大佬被曝巨额债务缠身，名下多处豪宅已被查封',
    excerpt: '据可靠消息，某音乐圈资深大佬因投资失败背负巨额债务，名下位于北京、上海、三亚的多处豪宅已被法院查封。多位圈内好友也被卷入债务纠纷。',
    category: '网曝猛料',
    categorySlug: 'mengliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20mansion%20with%20sealed%20notice%20on%20the%20gate%20at%20dusk%2C%20dramatic%20sky%20with%20dark%20clouds%2C%20cinematic%20moody%20atmosphere%2C%20foreboding%20tone%2C%20high-end%20architectural%20photography%20style&width=800&height=500&seq=article-hot-05&orientation=landscape',
    author: '财经八卦哥',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20coin%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design%2C%20gold%20and%20dark%20colors&width=80&height=80&seq=avatar-05&orientation=squarish',
    publishDate: '2026-07-05',
    readCount: '56.4万',
    commentCount: '1.5万',
    isHot: false,
    isExclusive: true,
    tags: ['债务', '查封', '音乐圈'],
  },
  {
    id: 6,
    slug: 'wanghong-qinglv-fenshou-neimu',
    title: '知名网红情侣分手内幕曝光，第三者竟是共同好友',
    excerpt: '曾经被称为"神仙眷侣"的某网红情侣突然宣布分手，真相竟是男方出轨两人的共同好友。女方在社交平台发长文控诉，细节令人心疼。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20broken%20heart%20silhouette%20against%20a%20sunset%20sky%2C%20emotional%20dramatic%20scene%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20composition%2C%20melancholic%20atmosphere%2C%20artistic%20photography&width=800&height=500&seq=article-hot-06&orientation=landscape',
    author: '情感吃瓜君',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20broken%20heart%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design%2C%20soft%20red%20colors&width=80&height=80&seq=avatar-06&orientation=squarish',
    publishDate: '2026-07-04',
    readCount: '142.1万',
    commentCount: '4.3万',
    isHot: true,
    isExclusive: false,
    tags: ['分手', '出轨', '网红情侣'],
  },
];

export const hotRanking = [
  { rank: 1, title: '某顶流男星被曝婚外情，深夜密会神秘女子', heat: '987654', change: 'up' },
  { rank: 2, title: '女星聊天记录外泄，内容尺度令人震惊', heat: '876543', change: 'up' },
  { rank: 3, title: '千万粉丝网红虚假人设被前员工实锤', heat: '765432', change: 'down' },
  { rank: 4, title: '头部主播带货产品检测出有害物质', heat: '654321', change: 'up' },
  { rank: 5, title: '网红情侣分手，第三者竟是共同好友', heat: '543210', change: 'new' },
  { rank: 6, title: '音乐圈大佬欠债数亿，豪宅被查封', heat: '432109', change: 'down' },
  { rank: 7, title: '某综艺嘉宾录制现场发生激烈冲突', heat: '321098', change: 'up' },
  { rank: 8, title: '娱乐圈某经纪公司被曝存在霸王条款', heat: '210987', change: 'new' },
];

export const videoArticles = [
  {
    id: 101,
    slug: 'shipin-mingxing-lu pai-toupo',
    title: '独家！某男星深夜街头与人争执，情绪失控画面曝光',
    duration: '03:28',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20night%20street%20scene%20with%20two%20people%20arguing%20under%20street%20lamps%2C%20blurry%20motion%2C%20cinematic%20noir%20style%2C%20wet%20pavement%20reflecting%20lights%2C%20dark%20moody%20atmosphere&width=600&height=380&seq=video-01&orientation=landscape',
    views: '256万',
    category: '明星塌房',
  },
  {
    id: 102,
    slug: 'shipin-wanghong-zhibo-fanche',
    title: '网红直播中突然接到电话，表情瞬间凝固全场安静',
    duration: '05:12',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20shocked%20expression%20on%20a%20streamer%20face%20illuminated%20by%20ring%20light%20in%20a%20dark%20room%2C%20dramatic%20lighting%2C%20suspenseful%20atmosphere%2C%20streaming%20setup%20visible%20in%20background&width=600&height=380&seq=video-02&orientation=landscape',
    views: '189万',
    category: '网红黑料',
  },
  {
    id: 103,
    slug: 'shipin-siren-paiju-mimi',
    title: '圈内人爆料：某女团私密聚会视频外流，场面混乱',
    duration: '08:45',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20private%20party%20scene%20with%20colorful%20neon%20lights%2C%20silhouettes%20of%20people%2C%20mysterious%20vibe%2C%20nightclub%20atmosphere%2C%20cinematic%20photography%20with%20grainy%20texture&width=600&height=380&seq=video-03&orientation=landscape',
    views: '312万',
    category: '91黑料',
  },
  {
    id: 104,
    slug: 'shipin-dianyingjie-heimu',
    title: '电影节后台被偷拍，某导演与女演员私密交谈内容解密',
    duration: '06:30',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20film%20festival%20backstage%20area%20with%20two%20people%20talking%20in%20shadows%2C%20red%20carpet%20visible%20in%20the%20distance%2C%20contrast%20between%20glamour%20and%20secrecy%2C%20cinematic%20composition&width=600&height=380&seq=video-04&orientation=landscape',
    views: '145万',
    category: '吃瓜视频',
  },
];

export const allArticles = [
  ...hotArticles,
  {
    id: 7,
    slug: 'zongyi-jiamu-xianchang-chongtu',
    title: '综艺录制现场突发冲突，两位嘉宾因一句话大打出手',
    excerpt: '某热门综艺最新一期录制过程中，两位常驻嘉宾因一句玩笑话发生激烈口角，随后演变为肢体冲突。现场工作人员紧急介入调解，录制被迫中断三个小时。',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20set%20with%20dramatic%20red%20lighting%2C%20two%20figures%20in%20confrontational%20pose%2C%20film%20crew%20equipment%20surrounding%2C%20tense%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20production%20environment&width=800&height=500&seq=article-07&orientation=landscape',
    author: '综艺密探',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20camera%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design&width=80&height=80&seq=avatar-07&orientation=squarish',
    publishDate: '2026-07-04',
    readCount: '89.7万',
    commentCount: '2.1万',
    isHot: false,
    isExclusive: true,
    tags: ['综艺', '冲突', '现场'],
  },
  {
    id: 8,
    slug: 'jingji-gongsi-bawang-tiaokuan',
    title: '娱乐圈经纪公司"霸王条款"曝光，新人签约如同卖身契',
    excerpt: '一份某大型经纪公司的内部合同被曝光，条款之苛刻令人震惊。新人签约后收入分成比例高达9:1，且捆绑期限长达15年，违约金高达千万级别。',
    category: '网曝猛料',
    categorySlug: 'mengliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20legal%20contract%20document%20with%20a%20magnifying%20glass%20on%20a%20dark%20desk%2C%20dramatic%20lighting%20from%20a%20single%20desk%20lamp%2C%20mysterious%20atmosphere%2C%20professional%20photography%2C%20warm%20dark%20tones&width=800&height=500&seq=article-08&orientation=landscape',
    author: '行业观察',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20document%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design&width=80&height=80&seq=avatar-08&orientation=squarish',
    publishDate: '2026-07-03',
    readCount: '67.2万',
    commentCount: '1.8万',
    isHot: false,
    isExclusive: false,
    tags: ['合同', '经纪公司', '霸王条款'],
  },
  {
    id: 9,
    slug: '51-heiliao-douyin-wanghong-baohei',
    title: '51黑料独家：某抖音网红被扒出曾参与非法集资',
    excerpt: '51黑料吃瓜独家爆料，某在抖音拥有超过500万粉丝的美食博主，被网友扒出在成名前曾参与一起非法集资案件，涉案金额高达数千万元。该博主目前尚未回应。',
    category: '51黑料',
    categorySlug: '51-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20with%20douyin%20app%20interface%20on%20screen%20on%20a%20dark%20desk%2C%20surrounded%20by%20legal%20documents%2C%20dramatic%20top-down%20lighting%2C%20investigative%20journalism%20style%2C%20warm%20dark%20moody%20tones&width=800&height=500&seq=article-09&orientation=landscape',
    author: '51爆料组',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20number%2051%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design%2C%20dark%20red%20colors&width=80&height=80&seq=avatar-09&orientation=squarish',
    publishDate: '2026-07-03',
    readCount: '201.3万',
    commentCount: '6.7万',
    isHot: true,
    isExclusive: true,
    tags: ['51黑料', '抖音网红', '非法集资'],
  },
  {
    id: 10,
    slug: '91-heiliao-wangluo-zhubao-zhaopian',
    title: '91黑料猛料：某知名网络主播私密照片遭泄露',
    excerpt: '91黑料吃瓜今日收到网友投稿，一组疑似某知名游戏主播的私密照片在暗网流传。该主播团队已紧急发布声明称照片系AI合成，但网友对比分析后认为可信度极高。',
    category: '91黑料',
    categorySlug: '91-heiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20gaming%20streaming%20setup%20with%20RGB%20lights%20in%20a%20dark%20room%2C%20monitor%20showing%20alarming%20notification%2C%20dramatic%20lighting%2C%20suspenseful%20atmosphere%2C%20cinematic%20photography%2C%20dark%20gaming%20aesthetic&width=800&height=500&seq=article-10&orientation=landscape',
    author: '91速报',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20number%2091%20icon%20avatar%20on%20clean%20white%20background%2C%20flat%20design&width=80&height=80&seq=avatar-10&orientation=squarish',
    publishDate: '2026-07-02',
    readCount: '278.6万',
    commentCount: '8.9万',
    isHot: true,
    isExclusive: false,
    tags: ['91黑料', '照片泄露', '游戏主播'],
  },
];

export const siteInfo = {
  name: '黑料吃瓜网',
  slogan: '一手大瓜，立刻开吃',
  description: '黑料吃瓜网是国内领先的娱乐资讯聚合平台，汇聚51黑料吃瓜、91黑料吃瓜、网曝一区二区等热门入口，实时更新全网独家网红黑料、明星塌房现场与每日吃瓜爆料视频。我们致力于为吃瓜群众提供最快、最全、最真实的娱乐爆料内容。',
  founded: '2019',
  articlesCount: '128,600',
  dailyVisitors: '850万',
  userSatisfaction: '96',
};